import { createStyles, Container, Group, Text } from '@mantine/core';
import { Link } from "react-router-dom"
import { appVersionComplete } from "../../utils/constants"

const useStyles = createStyles((theme) => ({
  footer: {
    borderTop: `1px solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
    }`,
    marginTop: 120,

    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },

  inner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,

    [theme.fn.smallerThan('xs')]: {
      flexDirection: 'column',
    },
  },

  links: {
    [theme.fn.smallerThan('xs')]: {
      marginTop: theme.spacing.md,
    },
  },
}));

interface FooterSimpleProps {
  links: { link: string; label: string }[];
}

export function FooterSimple({ links }: FooterSimpleProps) {

  const { classes } = useStyles();

  const items = links.map((link) => (
    <Text
      color="dimmed"
      key={link.label}
      component={Link}
      to={link.link}
      size="sm"
    >
      {link.label}
    </Text>
  ));

  return (
    <div className={classes.footer}>
      <Container className={classes.inner}>
        <Text size="xs">Moviebook @ All rights reserved - {appVersionComplete}</Text>
        <Group className={classes.links}>{items}</Group>
      </Container>
    </div>
  );
}
